import { IWizardCol } from './../../wizard/wizard-col.component';
import { WizardService } from './../../wizard/wizard.service';

export const step1Public: IWizardCol = {
  title: 'sessions.create.wizard.step1_1_public.title',
  subscription: new WizardService().getAccountTypeSubscription(),
  cols: [
    {
      title: 'sessions.create.wizard.step1_1_public.free',
      description: ['sessions.create.wizard.step1_1_public.free_description'],
      icon: 'unlock',
      option: 'free'
    },
    {
      title: 'sessions.create.wizard.step1_1_public.registration',
      description: [
        'sessions.create.wizard.step1_1_public.registration_description',
        'sessions.create.wizard.step1_1_public.social_description'
      ],
      icon: 'lock',
      option: 'registration'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/step/step1public.ts